type SnapAlign = 'end' | 'start' | 'center' | 'center-even' | 'center-odd' | undefined;

export function useCarousel() {
    const snapAlign:SnapAlign = 'start'

    const breakpoints = {
        700: {
            itemsToShow: 3,
            itemsToScroll: 3,
        },
        1024: {
            itemsToShow: 4,
            itemsToScroll: 4,
        },
    }
    const transition = 600
    return {
        snapAlign,
        breakpoints,
        transition,
    }
}
